import React, { FunctionComponent } from 'react'
import styled from 'styled-components'
import { AutoImage } from '../components/auto-image'
import { ContentContainer } from '../components/content-container'
import { HeaderImageContainer } from './recruit-page'

const Outer = styled.div`
  --background-color: #f5e6ec;
`

const Inner = styled.div`
  width: 100%;
  font-weight: 700;
`

const Title = styled.div`
  color: #96607a;
  font-size: 2rem;
  margin-bottom: 3rem;
`

const Head = styled.div`
  margin-top: 2rem;
  color: #96607a;
  font-size: 1.5rem;
  margin-bottom: 1rem;
`

const Text = styled.div`
  line-height: 1.75;
`

type RecruitPrivacyPolicyPageProps = {

}
export const RecruitPrivacyPolicyPage: FunctionComponent<RecruitPrivacyPolicyPageProps> = () => {
  return <Outer>
    <HeaderImageContainer>
      <AutoImage src="/images/recruit_header.jpg" mobileSrc="/images/recruit_header_mobile.jpg" />
    </HeaderImageContainer>
    <ContentContainer>
        <Inner>
        <Title>プライバシーポリシー</Title>
        <Head>1.基本方針</Head>
        <Text>認定こども園 ムロノキッズ （ 以下 「 当園 」 という ） は、みなさまに安心して 当サイトをご利用いただけるよう、個人情報の保護に関する 法律およびその他の法令を遵守し、個人情報の保護に努めます。</Text>
        <Head>2.個人情報の利用目的</Head>
        <Text>ご提供いただいた個人情報は、お問い合わせへのご返信や、 各種お申し込み、資料請求など、サイト運営上必要な範囲内においてのみ利用します。</Text>
        <Head>3.個人情報の安全対策</Head>
        <Text>個人情報を安全に管理・運営するよう努力し、当園が保有する個人情報への外部からの不正なアクセス、個人情報の紛失・破壊・改ざん・漏えい、園外への不正な流出などの防止策を講じます。</Text>
        <Head>4.個人情報の第三者への提供</Head>
        <Text>
          個人情報は、以下のいずれかに該当する場合を除いて、いかなる第三者にも開示や提供はいたしません。<br />
          <br />
          ・ご本人の同意がある場合。<br />
          ・裁判所、検察庁、警察、弁護士会またはこれらに準じた権限を有する機関から、法律に基づく正式な照会を受けた場合<br />
          ・利用目的の達成に必要な範囲で、機密保持契約を終結している信頼出来る業務委託先に対し、必要な範囲で開示する場合個人情報は、以下のいずれかに該当する場合を除いて、いかなる第三者にも開示や提供はいたしません。<br />
          ・裁判所、検察庁、警察、弁護士会またはこれらに準じた権限を 有する機関から、法律に基づく正式な照会を受けた場合<br />
          ・利用目的の達成に必要な範囲で、機密保持契約を終結している 信頼出来る業務委託先に対し、必要な範囲で開示する場合
        </Text>
        <Head>5.個人情報の免責事項</Head>
        <Text>
          以下の場合、第三者による個人情報の取得に関し、 当園は一切の責任を負いません。<br />
          <br />
          ・ご本人自らが、第三者が閲覧可能な場で個人情報を明らかにする場合<br />
          ・ご本人またはその他の方が入力した情報により本人が特定できてしまった場合<br />
          ・当ウェブサイトにリンクされている他のウェブサイトにおいて、ご本人より個人情報が提供された場合
        </Text>
        <Head>6.個人情報の開示・訂正・削除</Head>
        <Text>個人情報をお知らせいただきましたお客様は、いつでも当園に対して、当園が有している個人情報を、ご本人のみに開示または、削除をするように求めることができます。開示の結果、個人情報に誤りがある場合は、当園に対して、個人情報の訂正、または削除を要求することができます。 個人情報の取り扱いに関するお問い合わせは、下記までご連絡ください。</Text>
      </Inner>
    </ContentContainer>
  </Outer>
}